import React from 'react';

const MicrosoftLogo = () => {
    return (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H11.4046V11.3916H0V0Z" fill="#F25022" />
            <path d="M12.5955 0H24.0001V11.3916H12.5955V0Z" fill="#7FBA00" />
            <path d="M0 12.5811H11.4046V23.9727H0V12.5811Z" fill="#00A4EF" />
            <path d="M12.5955 12.5811H24.0001V23.9727H12.5955V12.5811Z" fill="#FFB900" />
        </svg>
    );
}

export default MicrosoftLogo;
